import { discordApiUrl, get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useAuthUserCreate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await post("user/authorize/auth0", param, false, true);
    }, options);
};

export const useFetchGuestUserDetails = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await get("user/guest?userId=" + param.userId);
    }, options);
};

export const useDiscordUserLogin = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (param: any) => {
        return await post("user/discord/token", param, false, true);
    }, options);
};

export const useDiscordOAuthUrl = (options?: UseMutationOptions<string, any, { clientId: string; redirectUri: string }, any>) => {
    return useMutation(async ({ clientId, redirectUri }) => {
        const oauthUrl = `${discordApiUrl}oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
            redirectUri
        )}&response_type=code&scope=identify%20email`;
        return oauthUrl;
    }, options);
};

// export const useDiscordOAuthUrl = (options?: UseMutationOptions<string, any, { clientId: string; redirectUri: string }, any>) => {
//     return useMutation(async ({ clientId, redirectUri }) => {
//         const oauthUrl = `${discordApiUrl}oauth2/authorize?client_id=${clientId}&permissions=${discordBotPermissions}&redirect_uri=${encodeURIComponent(
//             redirectUri
//         )}&response_type=code&integration_type=0&scope=bot+email+identify+guilds.join`;
//         return oauthUrl;
//     }, options);
// };